import PaymentHistoryVM from './payment-history-vm';
import CardService from '../../common/shop/card_service/card-service';

export default function (data) {
  let self = this;
  self.profile = ko.observable();

  self.defaultNoticeOptions = {
    method: 'append'
  };
  self.selectedPlanId = ko.observable(0);
  self.charges = ko.observableArray();

  self.membershipText = ko.computed(function() {
    return self.profile() && self.profile().premium_member() ? 'Kadenze Premium Member' : 'Free Member';
  });

  self.cancelSubscription = function() {
    $('#js-cancel-premium-modal').modal('show');
  };

  self.isGrandfathered = function() {
    const currentId = self.profile().shop_customer.subscription.stripe_json.plan.id();
    return ['year-195', 'month-20'].indexOf(currentId) === -1;
  };

  self.denySubscriptionCancel = function() {
    $('#js-cancel-premium-modal').modal('hide');
  };

  self.confirmSubscriptionCancel = function() {
    $('#js-cancel-premium-modal').modal('hide');
    Kadenze.UIUtil.showLoadingIndicator(null, null, 'fixed');
    let url = Kadenze.Routes.shop_subscription_path(self.profile().shop_customer.subscription.id());
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'DELETE'
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      // self.profile().paid_subscriber(false);
      self.profile().shop_customer.subscription.workflow_state('canceled');
      Kadenze.Analytics.track('membership', 'downgrade');
    });

    request.fail(function(xhr) {
      new Kadenze.Notice.error({ message: xhr.responseJSON.message });
    });

    request.always(function() {
      Kadenze.UIUtil.hideLoadingIndicator();
    });
  };

  self.reEnableSubscription = function() {
    let url = Kadenze.Routes.shop_reactivate_subscription_path(self.profile().shop_customer.subscription.id());
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'PATCH'
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      self.profile().shop_customer.subscription.workflow_state('active');
      Kadenze.Analytics.track('membership', 'reactivate');
    });

    request.fail(function(xhr) {
      let json = xhr.responseJSON;
      if (json.message) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      }
      else {
        new Kadenze.Notice.error({ message: 'An unexpected error occurred' });
      }

    });
  };

  self.doPlanChange = function(newPlan, activePlan) {
    let url = Kadenze.Routes.shop_change_subscription_plan_path(self.selectedPlanId());
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'POST'
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      newPlan.active(true);
      if (activePlan) {
        activePlan.active(false);
      }
    });

    request.fail(function(xhr) {
      let json = xhr.responseJSON;
      if (json.message) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      }
      else {
        new Kadenze.Notice.error({ message: 'An unexpected error occurred' });
      }

    });
  };

  self.terminateSubscription = function() {
    Kadenze.UIUtil.showLoadingIndicator(null, null, 'fixed');
    let url = Kadenze.Routes.shop_terminate_subscription_path(self.profile().shop_customer.subscription.id());
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'DELETE'
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      self.profile().paid_subscriber(false);
      self.profile().premium_member(false);
    });

    request.fail(function(xhr) {
      let json = xhr.responseJSON;
      if (json.message) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      }
      else {
        new Kadenze.Notice.error({ message: 'An unexpected error occurred' });
      }

    });

    request.always(function() {
      Kadenze.UIUtil.hideLoadingIndicator();
    });
  };

  self.handlePlanUpdate = function(id) {
    if (!self.cancelingPlanChange) {
      let $modal = $('#js-change-billing-cycle-modal');
      $modal.modal('show');
    } else {
      self.cancelingPlanChange = false;
    }
    return true;
  };

  self.setSelectedOnPlanRadio = function() {
    let id = self.selectedPlanId();
    let newPlan = ko.utils.arrayFirst(self.profile().plans(), function(item) {
      return item.id() == id;
    });
    $(`label[for="plan-${newPlan.data_id()}"]`).addClass('selected');
  };

  self.changeBillingCycle = function() {
    let $modal = $('#js-change-billing-cycle-modal');
    $modal.modal('hide');
    self.setSelectedOnPlanRadio();
    self.cancelingPlanChange = false;
    let newPlan = self.newPlan();
    let activePlan = self.activePlan();
    self.doPlanChange(newPlan, activePlan);
  };

  self.activePlan = function(){
    let activePlan = ko.utils.arrayFirst(self.profile().plans(), function(item) {
      return item.active();
    });
    return activePlan;
  };

  self.newPlan = function(){
    let newPlan = ko.utils.arrayFirst(self.profile().plans(), function(item) {
      return !item.active();
    });
    return newPlan;
  };

  self.cancelChangeBillingCycle = function() {
    let $modal = $('#js-change-billing-cycle-modal');
    $modal.modal('hide');
    self.cancelingPlanChange = true;
    self.selectedPlanId(self.activePlan().id());
    self.setSelectedOnPlanRadio();
  };

  self.bindData = function(data) {
    let mapped_profile = ko.mapping.fromJS(data, {ignore: ['first_name','last_name','current_password','password','password_confirmation']});
    self.profile(mapped_profile);
    self.profile().preferences = ko.mapping.fromJS(data.preferences);
    self.charges(data.charges || []);

    let activePlan = ko.utils.arrayFirst(self.profile().plans(), function(item) {
      return item.active();
    });

    if (activePlan) {
      self.selectedPlanId(activePlan.id());
    }

    self.selectedPlanId.subscribe(self.handlePlanUpdate);
  };

  self.initUI = function() {
    // Whenever a button is clicked in this VM, initUI is re-called once
    // this is a hack to prevent re-running initUI
    if (!self.paymentHistoryVM) {
      let updateCardBtn = document.getElementById('updateCard');
      if (updateCardBtn) {
        CardService.init(updateCardBtn);
      }
      const historyContainer = document.getElementById('js-payment-history-vm');
      if (historyContainer) {
        self.paymentHistoryVM = new PaymentHistoryVM(self.charges(), self.profile);
        ko.applyBindingsWithValidation(self.paymentHistoryVM, historyContainer, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
      }
    }
    // open this tab if URL hash is 'subscription'
    if (document.location.hash === '#subscription') {
      $('.kd-tab__tab-link[href="#subscriptionstatus"]').tab('show');
    }
  };

  const __construct = function(that) {
    console.log('constructor called for SubscriptionVM');
    that.bindData(data);
  }(this);
}

